// @flow
export const POLL_NODE_EXISTS = 'hive/honeycomb/POLL_NODE_EXISTS';
export const MAX_POLL_TIMEOUT = 60000;
export const CREATION_FAILED = 'FAILED';



// WEBPACK FOOTER //
// ./src/core/state/honeycomb/constants.js